import * as React from 'react';
import ContentContainer from '../../components/_layout/Page/ContentContainer';
import { __ } from '@bart.sk-eshop/react-i18n';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Clearfix } from '../../theme/libraries/h5b-helpers';
// import {
//   InputStyles,
//   InputStyledStyles,
// } from '../../components/_helpers/form/FormStyles';
import { ButtonStyled } from '../../components/_helpers/form/Button';
import Alert from '../../components/Alert/Alert';
import { InputStyled } from '../../components/_helpers/form/Input';
import { Label } from '../../components/_helpers/form/Label';
import { connect } from 'react-redux';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { CheckboxStyled } from '../../components/_helpers/form/Checkbox';
import {
  isEmailValid,
  prop,
  scrollToClass,
  scrollToTop,
} from '../../utilities';
import EmailAutocomplete from '../../components/_helpers/form/EmailAutocomplete';
import { Loader } from '../../components/_helpers/Loader/Loader';
import { ErrorPopup } from '../../components/_helpers/form/FormStyles';
import SetPreviews from '../../components/_helpers/Sets/SetPreviews';
import { Heading2 } from '../../components/_helpers/Heading/Heading';
import { loadUniversalSets, loadUniversalSetsSpecial } from '../Home/actions';
import ProductsSlider from '../../components/_helpers/product/ProductsSlider';
import { Container } from '../../theme/libraries/grid';
import { push } from 'react-router-redux';

// const Textarea: any = styled.textarea`
//   ${InputStyles};
//   ${InputStyledStyles};
//   display: block;
//   width: 100%;
//   height: auto;
//   ${(props: any) => {
//     return props.error ? 'border:1px solid red;' : '';
//   }}
// `;

const InputCss = css`
  display: block;
  width: 100%;

  &.small {
    ${({ theme }) => theme.media('xs')} {
      max-width: ${rem(290)};
    }
  }

  ${(props: any) => {
    return props.error ? 'border:1px solid red;' : '';
  }}
`;

const Input = styled(InputStyled)`
  ${InputCss};
`;

const InputEmail = styled(EmailAutocomplete)`
  ${InputCss};
`;

const Checkbox = styled(CheckboxStyled)`
  margin: ${rem(10)} 0 0;
  &.error {
    :before {
      border-color: ${({ theme }) => theme.color.error};
    }
  }
`;

const Row = styled(Clearfix)`
  margin-right: ${rem(-5)};
  margin-bottom: ${rem(10)};
`;

const Submit = styled(ButtonStyled)`
  display: block;
  margin-top: ${rem(20)};
`;

const SetsButton = styled(ButtonStyled)``;

const Wrapper = styled.form`
  max-width: 100%;
`;

const Text = styled.p``;

const ContentBox = styled.div``;

const LabelSecondaryText = styled.span`
  color: ${({ theme }) => theme.color.gray56};
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(20)};

  ${({ theme }) => theme.media('md')} {
    grid-template-columns: 1fr 1fr;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SetsHeading = styled(Heading2)`
  text-align: center;
  font-size: ${rem(16)};
  margin: ${rem(20)} 0;
  padding: 0 ${rem(8)};
  strong {
    font-weight: 800;
    font-size: ${rem(16)};
  }
  ${({ theme }) => theme.media('sm')} {
    text-align: left;
  }
  ${({ theme }) => theme.media('md')} {
    padding: 0 ${rem(40)};
    font-size: ${rem(20)};
    strong {
      font-size: ${rem(24)};
    }
  }
`;

const SetsWrapper = styled(Container)`
  margin-bottom: ${rem(40)};

  ${({ theme }) => theme.media('md')} {
    padding-top: ${rem(0)};
  }
`;

const SetsButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${rem(40)};
`;

interface Props {
  dispatch: any;
  universalSets: any[];
  universalSetsSpecial: any[];
}

interface States {
  loading: boolean;
  status: number;
  valueTown: string;
  valueEmail: string;
  valueSchool: string;
  valueUsage: string;
  valueClass: string;
  errorTown: string;
  errorEmail: string;
  errorSchool: string;
  errorUsage: string;
  errorClass: string;
  formSuccessfullySent: boolean;
  formSendError: boolean;
  agreeWithTerms: boolean | null;
}

class NotIncludedSchoolsFrom extends React.Component<Props, States> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      status: 0,
      valueTown: '',
      valueEmail: '',
      valueSchool: '',
      valueUsage: '',
      valueClass: '',
      errorTown: '',
      errorEmail: '',
      errorSchool: '',
      errorUsage: '',
      errorClass: '',
      formSuccessfullySent: false,
      formSendError: false,
      agreeWithTerms: null,
    };
  }

  public static async getInitialProps(props) {
    const promises: any[] = [];

    if (!props.universalSets || !props.universalSets.length) {
      promises.push(props.dispatch(loadUniversalSets()));
    }

    if (!props.universalSetsSpecial || !props.universalSetsSpecial.length) {
      promises.push(props.dispatch(loadUniversalSetsSpecial()));
    }

    await Promise.all(promises);
  }

  public validateForm = (e) => {
    e.preventDefault();
    let error = false;
    if (this.state.formSuccessfullySent) {
      this.setState({ formSuccessfullySent: false });
    }
    if (this.state.valueTown === '') {
      this.setState({ errorTown: __('Zadajte mesto/obec školy') });
      this.scrollToRef('town');
      error = true;
    }
    if (this.state.valueSchool === '') {
      this.setState({ errorSchool: __('Zadajte názov školy') });
      if (!error) {
        this.scrollToRef('school');
      }
      error = true;
    }
    if (this.state.valueEmail === '') {
      this.setState({ errorEmail: __('Zadajte váš email') });
      if (!error) {
        this.scrollToRef('email');
      }
      error = true;
    } else {
      if (!isEmailValid(this.state.valueEmail)) {
        this.setState({ errorEmail: __('Prosím, skontrolujte email') });
        if (!error) {
          this.scrollToRef('email');
        }
        error = true;
      }
    }
    if (!this.state.agreeWithTerms) {
      this.setState({ agreeWithTerms: false });
      if (!error) {
        this.scrollToRef('gdpr');
      }
      error = true;
    }
    if (error) {
      return;
    }

    this.props.dispatch(this.submitForm());
  };

  public submitForm = () => {
    return async (dispatch, getState, API) => {
      this.setState({ loading: true });
      try {
        const currentState = getState();
        await API.notIncludedSchoolsFrom(
          {
            xAcceptLanguage: currentState.general.lang,
          },
          {
            town: this.state.valueTown,
            school: this.state.valueSchool,
            usage: this.state.valueUsage,
            class: this.state.valueClass,
            email: this.state.valueEmail,
          },
        );
        this.setState({
          formSuccessfullySent: true,
          valueTown: '',
          valueSchool: '',
          valueUsage: '',
          valueClass: '',
          valueEmail: '',
        });
        scrollToTop();
      } catch (e) {
        this.setState({ formSendError: true });
      }
      this.setState({ loading: false });
    };
  };

  public changeTown = (e) => {
    if (this.state.errorTown !== '') {
      this.setState({ errorTown: '' });
    }
    this.setState({
      valueTown: e.target.value,
    });
  };

  public changeSchool = (e) => {
    if (this.state.errorSchool !== '') {
      this.setState({ errorSchool: '' });
    }
    this.setState({
      valueSchool: e.target.value,
    });
  };

  public changeUsage = (e) => {
    if (this.state.errorUsage !== '') {
      this.setState({ errorUsage: '' });
    }
    this.setState({
      valueUsage: e.target.value,
    });
  };

  public changeClass = (e) => {
    if (this.state.errorClass !== '') {
      this.setState({ errorClass: '' });
    }
    this.setState({
      valueClass: e.target.value,
    });
  };

  public changeEmail = (e) => {
    if (this.state.errorEmail !== '') {
      this.setState({ errorEmail: '' });
    }
    this.setState({
      valueEmail: e.target.value,
    });
  };

  public scrollToRef = (ref) => scrollToClass('.' + ref);

  public offset = (el) => {
    const rect = el.getBoundingClientRect();
    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  };

  public setAgreeWithTerms = (e) => {
    this.setState({ agreeWithTerms: e.target.checked });
  };

  public render() {
    return (
      <>
        <ContentContainer title={__('Nenašiel si svoju školu alebo ročník?')}>
          <ContentBox>
            {this.state.formSuccessfullySent && (
              <Alert type="success"> {__('Odoslanie prebehlo úspešne')} </Alert>
            )}

            {this.state.formSendError && (
              <Alert type="error">
                {' '}
                {__(
                  'Nepodarilo sa odoslať formulár. Skúste to, prosím, neskôr',
                )}{' '}
              </Alert>
            )}

            <Text>
              {__(
                'Vypíš prosím nasledujúci formulár a my sa pokúsime tvoju školu zaradiť do nášho zoznamu škôl, aby si si čo najskôr mohol pohodlne objednať zoznam školských potrieb, ktorý odporúča tvoj triedny učiteľ. V prípade ak chceš do zoznamu zaradiť viac škôl, vyplnenie dotazníku zopakuj. Ďakujeme za tvoj návrh.',
              )}
            </Text>

            <Wrapper onSubmit={this.validateForm}>
              <Loader loading={this.state.loading}>
                <FormGrid>
                  <InputWrapper>
                    <Label className="town">
                      {__('V akom meste/obci navštevujú vaše deti školu?')}{' '}
                      <LabelSecondaryText>({__('povinné')})</LabelSecondaryText>
                    </Label>
                    <Input
                      name="town"
                      value={this.state.valueTown}
                      onChange={this.changeTown}
                    />
                    {this.state.errorTown !== '' ? (
                      <ErrorPopup>{this.state.errorTown}</ErrorPopup>
                    ) : (
                      ''
                    )}
                  </InputWrapper>

                  <InputWrapper>
                    <Label className="school">
                      {__('Názov školy ktorú odporúčate zaradiť do Skvelka')}
                      <LabelSecondaryText>
                        {' '}
                        ({__('povinné')})
                      </LabelSecondaryText>
                    </Label>
                    <Input
                      name="school"
                      value={this.state.valueSchool}
                      onChange={this.changeSchool}
                    />
                    {this.state.errorSchool !== '' ? (
                      <ErrorPopup>{this.state.errorSchool}</ErrorPopup>
                    ) : (
                      ''
                    )}
                  </InputWrapper>

                  <InputWrapper>
                    <Label>
                      {__(
                        'Využívali ste už službu balíčka školských potrieb vo vašej škole?',
                      )}
                    </Label>
                    <Input
                      name="usage"
                      value={this.state.valueUsage}
                      onChange={this.changeUsage}
                    />
                    {this.state.errorUsage !== '' ? (
                      <ErrorPopup>{this.state.errorUsage}</ErrorPopup>
                    ) : (
                      ''
                    )}
                  </InputWrapper>

                  <InputWrapper>
                    <Label>
                      {__('Ktorý ročník bude navštevovať Vaše dieťa?')}
                    </Label>
                    <Input
                      name="concern"
                      value={this.state.valueClass}
                      onChange={this.changeClass}
                    />
                    {this.state.errorClass !== '' ? (
                      <ErrorPopup>{this.state.errorClass}</ErrorPopup>
                    ) : (
                      ''
                    )}
                  </InputWrapper>

                  <InputWrapper>
                    <Label className="email">
                      {__('Váš email')}{' '}
                      <LabelSecondaryText>({__('povinné')})</LabelSecondaryText>
                    </Label>
                    <InputEmail
                      name="email"
                      value={this.state.valueEmail}
                      onChange={this.changeEmail}
                      className="small"
                    />
                    {this.state.errorEmail !== '' ? (
                      <ErrorPopup>{this.state.errorEmail}</ErrorPopup>
                    ) : (
                      ''
                    )}
                  </InputWrapper>
                </FormGrid>

                <Checkbox
                  id="gdpr"
                  name="gdpr"
                  value="1"
                  onChange={this.setAgreeWithTerms}
                  className={
                    this.state.agreeWithTerms === null ||
                    this.state.agreeWithTerms
                      ? 'gdpr'
                      : 'gdpr error'
                  }
                >
                  {`${__('Súhlasím so')} `}
                  <a href="/gdpr" target="_blank">
                    {__('spracovaním osobných údajov')}
                  </a>
                </Checkbox>
                {this.state.agreeWithTerms === null ||
                this.state.agreeWithTerms ? (
                  ''
                ) : (
                  <ErrorPopup>
                    {__(
                      'Formulár nie je možné odoslať bez súhlasu o spracovaní osobných údajov.',
                    )}
                  </ErrorPopup>
                )}

                <Row>
                  <Submit type="submit" className="primary">
                    {__('Odoslať')}
                  </Submit>
                </Row>
              </Loader>
            </Wrapper>
          </ContentBox>
        </ContentContainer>
        <SetsWrapper className="base">
          <SetsHeading>
            {__('Nenašli ste vašu školu v zozname? Máme riešenie!')}
            <br />
            <strong>{__('Univerzálne zoznamy pomôcok pre žiakov')}</strong>
          </SetsHeading>
          <SetPreviews
            sets={this.props.universalSets}
            onUniversalSetClick={() => {}}
          />

          {this.props.universalSetsSpecial?.length ? (
            <>
              <SetsHeading>
                <strong>{__('Doplnkové sady a školské pomôcky')}</strong>
              </SetsHeading>
              <ProductsSlider
                products={this.props.universalSetsSpecial}
                breakpoints={{
                  1023: {
                    slidesPerView: 5,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  577: {
                    slidesPerView: 3,
                  },
                }}
              />
            </>
          ) : (
            ''
          )}
          <SetsButtonWrapper>
            <SetsButton
              className="primary"
              onClick={() => {
                this.props.dispatch(push('/sady'));
              }}
            >
              {__('Zoznamy pomôcok Skvelko')}
            </SetsButton>
          </SetsButtonWrapper>
        </SetsWrapper>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    universalSets: prop(state.home, 'universalSets', []),
    universalSetsSpecial: prop(state.home, 'universalSetsSpecial.products', []),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'NotIncludedSchoolsFrom' })(NotIncludedSchoolsFrom),
);
